// Форматирование для UI Vision.

/**
 * Дата публикации в карточке/деталях.
 *
 * RU — «1 июля 2026 г.» через Intl. KK — «01.07.2026» вручную: ICU для `kk-KZ`
 * с длинным месяцем сваливается в root-локаль и печатает «2026 M07 1»
 * (проверено на живой ленте) — числовой формат честнее любого фолбэка.
 */
export function formatDate(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  if (language.startsWith('kk')) {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
  }
  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

/**
 * Денежная сумма без символа валюты («23 000»).
 *
 * Символ ₸ дописывает вызывающий: в калькуляторах он часть переводимой строки.
 * Группировка у `ru-RU` и `kk-KZ` совпадает (неразрывный пробел) — локаль всё
 * равно передаём, чтобы не зашивать русское форматирование в казахский UI.
 */
export function formatMoney(value: number, language: string): string {
  const locale = language.startsWith('kk') ? 'kk-KZ' : 'ru-RU';
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
}

/** Город + район одной строкой («Астана, Есиль р-н»). */
export function formatPlace(city: string, district: string | null): string {
  return district ? `${city}, ${district}` : city;
}

/**
 * Телефон E.164 для показа: «+7 913 985 11 35». Группировка — для номеров
 * +7 (Казахстан/Россия, 10 цифр после кода); остальные — как есть.
 */
export function formatPhone(e164: string): string {
  const m = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  return m ? `+7 ${m[1]} ${m[2]} ${m[3]} ${m[4]}` : e164;
}
